import jsonUtils from "./jsonUtils";
import maskUtils from "./maskUtils";
import stringUtils from "./stringUtils";

const tratamento = {
  ...maskUtils,
  lista: function (val) {
    if (!Array.isArray(val)) {
      return [val];
    }
    return val;
  },
  limparLista3: function (val, atributos) {
    try {
      let item = atributos[2].nome;
      let nova_lista = val.filter((it) => {
        let valor = jsonUtils.getValor(item, it);
        return (
          valor != undefined &&
          valor != "" &&
          valor != " " &&
          valor != "0" &&
          valor != 0 &&
          valor != "-"
        );
      });
      return nova_lista;
    } catch (err) {}
    return val;
  },
  formatMoney: function (n) {
    if (isNaN(n) && n != null && n != undefined) {
      n = n.replaceAll(".", "");
      n = n.replace(",", ".");
    }

    return isNaN(n) ? n : stringUtils.formatBRL(n);
  },
  formatMoney2: function (n) {
    try {
      if (isNaN(n) && n != null && n != undefined) {
        n = n.replaceAll(".", "");
        n = n.replace(",", ".");
      }

      return isNaN(n)
        ? n
        : stringUtils.formatBRL(n).replace("R$", "").split(",")[0];
    } catch (e) {}
    return n;
  },
  removerDiaData: function (n) {
    if (n && n.split("/").length === 3) {
      let n_list = n.split("/");
      n = `${n_list[1]}/${n_list[2]}`;
    }
    return n;
  },
  removerDiaData2: function (n) {
    if (n && n.split("-").length > 1) {
      let n_list = n.split("-");
      n = `${n_list[1]}/${n_list[0]}`;
    }
    return n;
  },
  data2: function (n) {
    if (n && n.split("-").length > 2) {
      let n_list = n.split("-");
      n = `${n_list[2].substring(0, 2)}/${n_list[1]}/${n_list[0]}`;
    }
    return n;
  },
  serasaDataEmNumerosParaDataBR: function(n) {
    return String(n).replace(/(\d{1,2})(\d{4})/g, "$1/$2")
  },
  getSize: function (obj) {
    if (obj == undefined || obj == null) {
      return "Nada consta";
    }
    if (!Array.isArray(obj)) {
      obj = [obj];
    }
    return obj.length;
  },
  zerarNulo: function (val) {
    if (val == undefined) {
      return 0;
    }
    return val;
  },
  porcentagem: function (val) {
    return val + "%";
  },
  center: (val) => {
    return val;
  },
  "center-texto": function (val) {
    return val;
  },
  negrito: function (val) {
    return val;
  },
  quebraLinha: function (val) {
    itens = val.replace(/\n/g, "<br />");
    return itens;
  },
  booleanValue: function (val) {
    return val ? "Sim" : "Não";
  },
  uppercase: function (val) {
    try {
      return val.toUpperCase();
    } catch (e) {
      return "";
    }
  },
  graficoScore: function (val) {
    // var id = generateUUID();
    // window.setTimeout(function () {
    //   $("#" + id).kumaGauge({
    //     label: {
    //       display: true,
    //       left: "Min",
    //       right: "Max",
    //       fontFamily: "Helvetica",
    //       fontColor: "#1E4147",
    //       fontSize: "11",
    //       fontWeight: "bold",
    //     },
    //     fill: "0-#fa4133:0-#fdbe37:50-#1cb42f:100",
    //     min: 0,
    //     max: 1000,
    //     value: val,
    //     showNeedle: false,
    //   });
    // }, 200);
    // return (
    //   '<span align="center"> <div id="' +
    //   id +
    //   '" class="js-gauge demo gauge">&#160;</div></span>'
    // );
    // if(true){

    // }
    return val;
  },
  float(value) {
    if (["number", "string"].includes(typeof value)) {
      return Number(value).toFixed(3);
    }
  },
  dataInvertida(value) {
    if (typeof value === "string" && value.match(/^\d{8}$/)) {
      const dia = value.slice(6, 8);
      const mes = value.slice(4, 6);
      const ano = value.slice(0, 4);
      return `${dia}/${mes}/${ano}`;
    }
  },
  dataQuod(obj) {
    try {
      return `${obj.Day}/${obj.Month}/${obj.Year}`
    } catch(e) {
      return ""
    }
  },
  numeroInteiro(value) {
    try {
      return Math.floor(Number(value));
    } catch(e) {
      return "";
    }
  },
  CEP(value) {
    try {
      if(value[0] === "0" && value.length === 9) {
        return `${value.slice(1, 6)}-${value.slice(6, 9)}`;
      }
    } catch (e) {
      return "";
    }
  }
};

const tratamentoUtils = {
  executarTratamento: (str_tratamento, valor) => {
    if (
      str_tratamento != undefined &&
      str_tratamento != null &&
      str_tratamento != ""
    ) {
      let tratamentos = str_tratamento.split(",");
      for (let t of tratamentos) {
        if (tratamento[t]) {
          valor = tratamento[t](valor);
        }
      }
    }
    return valor;
  },
  limparLista(str_tratamento, valor, atributos) {
    if (
      str_tratamento != undefined &&
      str_tratamento != null &&
      str_tratamento != ""
    ) {
      let tratamentos = str_tratamento.split(",");
      for (let t of tratamentos) {
        valor = tratamento[t](valor, atributos);
      }
    }
    return valor;
  },
};

export default tratamentoUtils;
